export default __webpack_public_path__ + "static/media/remotecoach-logo.83d8d908.jpg";